module.exports = __webpack_public_path__ + "static/media/subscribe-our-youtube-channel.830d09e2.png";